import { StrictMode } from 'react';
import { createRoot, Root } from 'react-dom/client';
import reportWebVitals from '@/reportWebVitals';
import '@/index.css';
import App from "@/App";

const rootElement = document.getElementById('root');
if (rootElement) {
  const root: Root = createRoot(rootElement);
  if (process.env.NODE_ENV === 'development') {
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    )
  } else {
    root.render(
      <App />
    )
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
